/**
 * KAN-674: рейтинг продавца кликом по звёздам. Одна мутация PATCH
 * /telegram-sellers/{id}/ {rating} (useTelegramSellerMutations) для блока
 * "Продавцы" и для строки аккаунта; повторный клик по текущей звезде снимает
 * рейтинг (null), на время запроса звёзды выключены, ошибка текстом под ними.
 */
import { useState } from 'react';
import { RatingStars } from '@/components/telegram/RatingStars';
import { useTelegramSellerMutations } from '@/hooks/useTelegramSellers';
import { extractErrorMessage } from '@/lib/extractErrorMessage';
import type { TelegramSellerBrief } from '@/types/telegramSeller';

interface Props {
  seller: Pick<TelegramSellerBrief, 'id' | 'rating'>;
  testId: string;
  /** По умолчанию `${testId}-error`. */
  errorTestId?: string;
}

export function SellerRatingEditor({ seller, testId, errorTestId }: Props): JSX.Element {
  const { update } = useTelegramSellerMutations();
  const [error, setError] = useState<string | null>(null);

  const setRating = (rating: number | null): void => {
    setError(null);
    update.mutate(
      { id: seller.id, data: { rating } },
      { onError: (err) => setError(extractErrorMessage(err, 'Не удалось сохранить рейтинг')) }
    );
  };

  return (
    <>
      <RatingStars
        value={seller.rating}
        onChange={setRating}
        disabled={update.isPending}
        testId={testId}
      />
      {error && (
        <span className="text-xs text-red-700" data-testid={errorTestId ?? `${testId}-error`}>
          {error}
        </span>
      )}
    </>
  );
}
